import styled from 'styled-components';
export const ProvenanceWrapper = styled.div `
  // WRAPPER STYLE
  position: relative;
  width: 100%;

  // BEGIN LEDGER FORM FIELD
  & .column-content {
    position: relative;
    overflow: hidden;
  }

  &[data-ocr='true'][data-edit='false'] .column-content:after {
    display: inline-block;
    content: '';
    left: 0;
    top: 0;
    border-width: 12px 12px 0 0;
    border-color: #ed7cd4 transparent transparent transparent;
    border-style: solid;
    position: absolute;
    z-index: 2;
  }
  // END LEDGER FORM FIELD
`;
